<template>
  <div class="doctor-consult">
    <div class="page_title">经典书籍列表</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <div>
            <span>书籍名称</span>
            <el-input
              v-model="book_name"
              class="myinput"
              @input="search"
              clearable
            ></el-input>
            <span>书籍分类</span>
            <el-select
              v-model="category_id"
              placeholder="请选择"
              class="myinput"
            >
              <el-option
                v-for="item in options"
                :key="item.category_id"
                :label="item.category_name"
                :value="item.category_id"
              >
              </el-option>
            </el-select>
            <span>作者</span>
            <el-input
              v-model="author"
              class="myinput"
              @input="search"
              clearable
            ></el-input>
            <span>状态</span>
            <el-radio-group
              v-model="status"
              @change="search"
              style="margin: 0 15px 0 8px"
            >
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">未上架</el-radio>
              <el-radio :label="2">已上架</el-radio>
            </el-radio-group>
            <el-button
              plain
              style="margin-left: 10px; background: #ececec"
              @click="search"
              >查询</el-button
            >
          </div>
        </div>
        <div style="margin-bottom: 16px">
          <el-button
            type="primary"
            size="medium"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('672') : false
            "
            @click="toBookClassify"
            >书籍分类</el-button
          >
          <el-button
            type="primary"
            size="medium"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('667') : false
            "
            @click="addBook"
            >添加书籍</el-button
          >
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="doctorTableRef"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="书籍名称"
              prop="book_name"
            ></el-table-column>
            <el-table-column label="作者" prop="author"></el-table-column>
            <el-table-column
              label="书籍分类"
              prop="category_name"
            ></el-table-column>
            <el-table-column label="封面图片" width="300px" align="center">
              <template slot-scope="scope">
                <img :src="scope.row.pic_path" alt="" style="width: 200px" />
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">待上架</span>
                <span v-if="scope.row.status == 2">已发布</span>
                <span v-if="scope.row.status == 3">已下架</span>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="infoDetail(scope.row.book_id)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('668')
                      : false
                  "
                  size="medium"
                  >详情</el-button
                >
                <el-button
                  v-if="scope.row.status != 2"
                  @click="changeStatus(scope.row.book_id, 2)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('669')
                      : false
                  "
                  size="medium"
                  >上架</el-button
                >

                <el-button
                  v-if="scope.row.status == 2"
                  @click="changeStatus(scope.row.book_id, 3)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('669')
                      : false
                  "
                  size="medium"
                  >下架</el-button
                >

                <el-button
                  v-if="scope.row.status != 2"
                  @click="infoDel(scope.row.book_id)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('670')
                      : false
                  "
                  size="medium"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center">
          <pagination
            v-show="totalNum > 0"
            :total="totalNum"
            :page.sync="pagination.page"
            :limit.sync="pagination.pageNumber"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import imgtext from '../../../api/imgtext';
import Pagination from '../../../components/Pagination/index';
import dayjs from 'dayjs';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableData: [],
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      book_name: '',
      category_id: '',
      author: '',
      status: 0,
      detail: {},
      options: []
    };
  },

  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        book_name: this.book_name,
        category_id: this.category_id,
        author: this.author,
        status: this.status,
        page: this.pagination.page,
        pageNumber: this.pagination.pageNumber
      };
      this.axios.post('platform/library/getBookList', data).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.totalNum = data.total;
          if (!data.list.length && this.pagination.page > 1) {
            this.pagination.page = this.pagination.page - 1;
            this.getList();
          } else {
            let list = data.list.map((item) => {
              if (item.update_time) {
                item.update_time = dayjs
                  .unix(item.update_time)
                  .format('YYYY-MM-DD HH:mm');
              } else {
                item.update_time = '待定';
              }
              return item;
            });
            this.tableData = list;
          }
        }
      });
    },
    // 获取分类列表
    getClassList() {
      this.axios.post('platform/library/getBookCategoryList').then((res) => {
        this.options = res.data.list;
      });
    },
    search() {
      this.pagination.page = 1;
      this.getList();
    },
    // 阅读量
    readNumClick(data) {
      this.readForm.read_num = data.read_num;
      this.readForm.info_id = data.info_id;
      this.readDialog = true;
    },
    confirmRead() {
      imgtext.changeDoctorInfoReadNum(this.readForm).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success('修改成功');
          this.getList();
        }
        this.readDialog = false;
      });
    },
    //排序
    updateSort(data, sort) {
      if (this.totalNum == 1) {
        this.$message.warning('只有一条数据哦');
        return;
      }
      let params = {
        info_id: data.info_id,
        sort
      };
      imgtext.editDoctorInfoSort(params).then((res) => {
        if (res.code == 0) {
          this.getList();
        }
      });
    },
    //添加
    addBook() {
      this.$router.push('addbook');
    },
    //添加分类
    toBookClassify() {
      this.$router.push('bookclassification');
    },
    // 详情
    infoDetail(book_id) {
      this.$router.push({
        path: 'addbook',
        query: { book_id }
      });
    },
    // 发布/下架
    changeStatus(book_id, status) {
      this.axios
        .post('platform/library/changeBookStatus', { book_id, status })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功');
            this.getList();
          }
        });
    },
    // 删除
    infoDel(book_id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.axios
          .post('platform/library/deleteBookInfo', { book_id })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('删除成功');
              this.getList();
            }
          });
      });
    }
  },
  created() {
    this.getList();
    this.getClassList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.searchbox {
  display: flex;
  margin-bottom: 16px;
  align-items: center;
}
.myinput {
  width: 135px;
  margin: 0 15px 0 10px;
}
</style>

